var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex items-center px-6 py-5 rounded-lg details--box"
  }, [_vm.logo ? _c('img', {
    staticClass: "object-contain object-center w-12 h-10 mr-3 -ml-1",
    attrs: {
      "src": _vm.logo
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "details--title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm.subtitle ? _c('p', {
    staticClass: "details--subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };